/**
 * Shared deep-link builders for navigating straight into a project with an
 * auto-open action queued — consumed by ProjectDetailView's `?suggest=` /
 * `?workflow=` query-param handling. Keep every "jump into a project and do
 * X" link on the same URL shape (Insights "Start Renewal", the bell's
 * renewal reminders, the future Guide navigator).
 */

// Falls back to the customer page when there's no project to land in yet.
export function renewalDeepLink(customerId: string, projectId?: string | null): string {
  if (!projectId) return `/customers/${customerId}`;
  return `/customers/${customerId}/projects/${projectId}?tab=workflows&suggest=renewal`;
}

// Lands in a project and auto-opens one exact workflow suggestion by key —
// used by the intake modal's "Run with these documents" (SMART_INTAKE_PLAN.md
// Phase 2), right after filing a brand-new project that this browser tab has
// no other route into yet.
export function suggestionDeepLink(customerId: string, projectId: string, suggestionKey: string): string {
  return `/customers/${customerId}/projects/${projectId}?tab=workflows&run=${encodeURIComponent(suggestionKey)}`;
}
